import React from "react";

const BatchSummaryTableHeader = () => {
  return (
    <>
      <tr>
        <th className="align-middle" rowSpan={2}>
          Batch ID
        </th>
        <th rowSpan={1} colSpan={3}>
          Closing Balance
        </th>
        {/* <th></th> */}
      </tr>
      <tr>
        <th>Quantity</th>
        <th>Rate</th>
        <th>Value</th>
        {/* <th></th> */}
      </tr>
    </>
  );
};

export default BatchSummaryTableHeader;
